export const dateTimePickerSchema = {
  properties: {
    dateTime: {
      calc: [
        'if (!this.date || !this.time) {',
        '  return null;',
        '}',
        'var dateString = this.date + "T" + this.time + ".000";',
        'var timezoneOffset = new Date().getTimezoneOffset() / 60;',
        'var timezoneMinutes = ((timezoneOffset % 1) * 60).toString().padStart(2, "0");',
        'var timezoneHours = Math.floor(Math.abs(timezoneOffset)).toString().padStart(2, "0");',
        'var timezoneString = (timezoneOffset > 0 ? "-" : "+") + timezoneHours + ":" + timezoneMinutes;',
        'return dateString + timezoneString;'
      ],
      fieldRequired: false,
      title: 'Data',
      type: 'string'
    },

    date: {
      disabled: 'this.isDisabled',
      fieldRequired: 'this.isRequired',
      format: 'date',
      title: 'Data',
      type: 'string'
    },

    time: {
      disabled: 'this.isDisabled',
      fieldRequired: 'this.isRequired',
      format: 'time',
      title: 'Godzina',
      type: 'string'
    },

    isRequired: {
      type: 'boolean'
    },

    isDisabled: {
      type: 'boolean'
    }
  },
  type: 'object'
};
